import React, { useState } from "react";
import { Layout, Typography } from "antd";
import Sidebar from "components/Sidebar";
import { useNavigate } from "react-router-dom";
import { IDomainsConfig } from "pages/Ponds/types";
import "./style.scss";

const { Header, Content, Footer } = Layout;
const { Title } = Typography;

const Home: React.FC = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [selectedDomain, setSelectedDomain] = useState<IDomainsConfig | null>(null);
  const navigate = useNavigate();

  const handleDomainSelect = (domain: IDomainsConfig) => {
    setSelectedDomain(domain);
    navigate(`/explorer/${domain.display_name}`);
  };

  // fullWidth for sidebar margin
  const fullWidth = 300;

  return (
    <Layout style={{ marginLeft: collapsed ? 80 : fullWidth }}>
      <Sidebar
        collapsed={collapsed}
        onCollapse={setCollapsed}
        selectedDomainKey={selectedDomain?.display_name}
        onDomainSelect={handleDomainSelect}
      />
      <Layout>
        <Header style={{ padding: 0 }} />
        <Content style={{ margin: "0 0" }}>
          <div className="main p60">
            <div className="inner-main">
              <Title level={1} className="main-title">
                Nexus: Your One-Stop Shop for PH R&D Data & AI
              </Title>
              <div className="main-subtitle">
                Unlock the Power of Data Science and AI with seamless self-service
                capabilities
              </div>
              <p className="main-descr">
                Nexus is your gateway to a unified Data, Data Science, and AI/ML
                platform. This self-service portal simplifies access to tools, data,
                and resources, accelerating your journey from insights to action.
                Explore, analyze, and build with cutting-edge capabilities at your
                fingertips.
              </p>
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Home;
